import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { APINames } from "../../../../legacy/api/api.names";
import { SettingsSubHeaderDesktop } from "../../../../ui";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";
import { Wrapper as CommonWrapper } from "../Common";
import { getRequiredSettings } from "../Common/Autoplay.utils";
import { IAutoplaySetting } from "../Common/AutoplaySettings";
import { AutoplaySettings } from "../Common/AutoplaySettings.view";
import { ResetButton } from "./components/AutoplayButtons";
import { Title } from "./components/Title";

interface IAutoplayAdvancedDesktopProps {
  onChange: (setting: IAutoplaySetting) => void;
  onReset: () => void;
  disabled: boolean;
  title: string;
  subtitle: string;
  requiredText: string;
  resetButtonLabel: string;
  settings: IAutoplaySetting[] | null;
}

export function AutoplayAdvancedDesktop({
  settings,
  disabled,
  title,
  subtitle,
  onChange,
  onReset,
  resetButtonLabel,
  requiredText
}: IAutoplayAdvancedDesktopProps) {
  const isRequiredSetting = getRequiredSettings(settings).length > 0;
  const someSettingIsActive = settings?.some(x => x.active) || false;
  const isResetEnabled = settings?.some(x => x.active || x.attributes?.value);

  const [expanded, setExpanded] = useState(
    isRequiredSetting || someSettingIsActive
  );

  const onClickOnTitle = () => {
    if (!isRequiredSetting && !disabled) {
      setExpanded(!expanded);
    }
  };

  if (!Array.isArray(settings) || !settings.length) {
    return null;
  }

  return (
    <Wrapper
      disabled={disabled}
      data-e2e-id={E2EIdentifier.AUTOPLAY_SETTINGS_CONTAINER}
    >
      <Title
        apiName={APINames.AUTOPLAY_ADVANCED_SETTING_BUTTON}
        title={title}
        onClick={onClickOnTitle}
        expand={expanded}
        disabled={disabled}
      />
      {expanded && (
        <>
          <AdvancedSettingsSubHeaderDesktop
            data-e2e-id={E2EIdentifier.AUTOPLAY_SETTINGS_SUBTITLE}
          >
            {subtitle}
          </AdvancedSettingsSubHeaderDesktop>
          <AutoplaySettings
            settings={settings}
            onChange={onChange}
            disabled={disabled}
            requiredText={requiredText}
          />
          <ResetButton
            data-e2e-id={E2EIdentifier.AUTOPLAY_RESET_BUTTON}
            label={resetButtonLabel}
            onClick={onReset}
            disabled={!isResetEnabled}
          />
        </>
      )}
    </Wrapper>
  );
}

const AdvancedSettingsSubHeaderDesktop = styled(SettingsSubHeaderDesktop)`
  height: 3.9em;
`;

export const Wrapper = styled(CommonWrapper)`
  margin-top: 2em;
  width: 50%;
  font-size: 0.8em;
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  pointer-events: ${props => (props.disabled ? "none" : "initial")};
`;
